/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.PortalInstanceListingRpc
 */

export const getPortalInstanceListingRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.PortalInstanceListingRpc',
  rpcName: 'getPortalInstanceListing',
  auth: 'external',
  fingerprint: 'uW-9mkShV_qeYNBVVdEN0kWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listPortalInstancesOnSameDomainRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.PortalInstanceListingRpc',
  rpcName: 'listPortalInstancesOnSameDomain',
  auth: 'external',
  fingerprint: 'VoMbFSBsLhrV7JfTOZzzakWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};